export default class OrderType {
	description = null;
	display_description = null;
	hold_inv_weeks = null;
	is_read_only = null;
	is_solo_type = null;
	name = null;
	order_type_group = null;
	order_type_id = null;

	constructor(order_type) {
		if (order_type) {
			this.description = order_type.Description;
			this.display_description = order_type.DisplayDescription;
			this.hold_inv_weeks = order_type.HoldInvoiceWeeks;
			this.is_read_only = order_type.IsReadOnly;
			this.is_solo_type = order_type.IsSoloType;
			this.name = order_type.Name;
			this.order_type_group = order_type.OrderTypeGroup;
			this.order_type_id = order_type.OrderTypeId;
		}
	}

	serialize(order_type) {
		return {
			OrderTypeId: order_type.order_type_id,
			Name: order_type.name,
			HoldInvoiceWeeks: order_type.hold_inv_weeks,
			IsReadOnly: order_type.is_read_only,
			OrderTypeGroup: order_type.order_type_group,
			IsSoloType: order_type.is_solo_type,
			DisplayDescription: order_type.display_description,
			Description: order_type.description,
		};
	}
}



// WEBPACK FOOTER //
// ./src/api/models/OrderType.js